import * as Cesium from "cesium";
import { CENTER } from "./effectConfig";

/**
 * 粒子特效（对齐 Cesium 官方 ParticleSystem 用法）
 * - 用 ENU 矩阵定位，不依赖 entity.computeModelMatrix
 * - lifetime 用有限值 + loop
 * - sizeInMeters，远距离相机也能看见
 */
export default class ParticleLight {
  constructor(viewer, color = Cesium.Color.WHITE, options = {}) {
    this.viewer = viewer;

    const lng = options.lng ?? CENTER.lng;
    const lat = options.lat ?? CENTER.lat;
    const ground = options.groundHeight ?? 1110;
    const height = options.height ?? ground + 200;

    const position = Cesium.Cartesian3.fromDegrees(lng, lat, height);
    const modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(position);

    // 定位锚点（半透明点，便于确认位置）
    this.boxEntity = viewer.entities.add({
      position,
      point: {
        pixelSize: 10,
        color: color.withAlpha(0.85),
        outlineColor: Cesium.Color.WHITE,
        outlineWidth: 1,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      },
    });

    this.particleSystem = new Cesium.ParticleSystem({
      image: `${process.env.BASE_URL}texture/smoke.png`,
      startColor: color.withAlpha(0.85),
      endColor: Cesium.Color.WHITE.withAlpha(0.0),
      startScale: 1.0,
      endScale: 4.0,
      minimumParticleLife: 1.2,
      maximumParticleLife: 3.5,
      minimumSpeed: 2.0,
      maximumSpeed: 12.0,
      imageSize: new Cesium.Cartesian2(40, 40),
      sizeInMeters: true,
      emissionRate: 40,
      emitter: new Cesium.BoxEmitter(new Cesium.Cartesian3(120, 120, 200)),
      lifetime: 16.0,
      loop: true,
      modelMatrix,
      emitterModelMatrix: Cesium.Matrix4.clone(Cesium.Matrix4.IDENTITY),
    });

    viewer.scene.primitives.add(this.particleSystem);
    console.log("[ParticleLight] 已创建", { lng, lat, height });
  }

  setVisible(show) {
    this.particleSystem.show = show;
    this.boxEntity.show = show;
  }
}
